import { render, staticRenderFns } from "./BaseRadioInput.vue?vue&type=template&id=79a2939b&scoped=true&"
import script from "./BaseRadioInput.vue?vue&type=script&lang=ts&"
export * from "./BaseRadioInput.vue?vue&type=script&lang=ts&"
import style0 from "./BaseRadioInput.vue?vue&type=style&index=0&id=79a2939b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a2939b",
  null
  
)

export default component.exports